import * as Yup from 'yup';
export const PasswordResetSchema = Yup.object().shape({
    email: Yup.string().required('E-mail jest wymagany').min(3, 'Fraza jest za krótka').email('Niepoprawny adres e-mail'),
    password: Yup.string().required('Hasło jest wymagane').min(8, 'Hasło jest za krótkie'),
});
